import { StudyPhaseRouteSync } from '../studyPhase/StudyPhaseRouteSync';
import ProtectedRoute from './ProtectedRoute';
import AIDrawerRenderer from '../components/ora/Global/AIDrawer/AIDrawerRenderer';
import TextSelectionTooltip from '../components/ora/Global/TextSelectionTooltip';
import OsShell from '../os/OsShell';
import SessionGates from '../session/SessionGates';
import ChatDocumentViewerProvider from '../providers/ChatDocumentViewerProvider';
import { AudioOverviewLectureOpenerBridge } from '../audioOverview/transcript/audioOverviewLectureOpener';
import AdminStepUpModal from '../components/ora/Admin/AdminStepUp/AdminStepUpModal';
import { useRefreshAfterCompanionAction } from '../components/ora/Chat/Companion/useRefreshAfterCompanionAction';

const ProtectedLayout = () => {
  useRefreshAfterCompanionAction();

  return (
    <ProtectedRoute>
      <StudyPhaseRouteSync>
        {/* Session-wide checks (assents, welcome, the checkout return, links
            from outside the app) sit above the window system so they run on
            every route — whatever component happens to own `/`. */}
        <SessionGates>
          <ChatDocumentViewerProvider>
            {/* Lets the Audio Overview transcript (outside the router) open
                a lecture's source page in the viewer. */}
            <AudioOverviewLectureOpenerBridge />
            <OsShell />
            <AIDrawerRenderer />
            <TextSelectionTooltip />
            {/* Opened by the axios client when an admin call needs a fresh
                passkey verification (ORA-864). */}
            <AdminStepUpModal />
          </ChatDocumentViewerProvider>
        </SessionGates>
      </StudyPhaseRouteSync>
    </ProtectedRoute>
  );
};

export default ProtectedLayout;
